import API from '../../api/api';
import * as actionTypes from '../actionTypes';

function getApiData(uuid,apiPath) {
  return (dispatch) => {
    API.getAxios(apiPath).get(`/pratica/${uuid}`)
      .then(response => {
        //console.log(`Funzione GETAPIDATA(): `,response);
        dispatch({ type: actionTypes.SAVE_DATA, payload: response.data});
        dispatch({type: actionTypes.LOADING_UUIDGET_FALSE});
      })
      .catch(errore => {
        dispatch({type: actionTypes.LOADING_UUIDGET_FALSE});
        dispatch({type: actionTypes.ERROR_UUIDGET, payload: errore.response.data});
      })
  };
}

export default getApiData;